<template>
 <div class="wage_box">
   <div class="top_tabs">
     <el-tabs v-model="activeNames"  stretch @tab-click="handleClickTops">
       <el-tab-pane label="Accountant View" name="first">
       </el-tab-pane>
       <el-tab-pane label="Business View" name="second">
       </el-tab-pane>
     </el-tabs>
   </div>
  <div v-if="activeNames == 'first'">
    <div class="tasksTop">
      <div class="topSeach">
        <div style="display: flex;flex-wrap: wrap">
          <div class="innerSearch">
            <el-select v-model="group_input"
                       filterable
                       remote
                       :loading="loading"
                       :remote-method="remoteGroupMethod"
                       @change="changeGroupHandle"
                       placeholder="All">
              <el-option
                v-for="item in group_option"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
              <div slot="prefix" >
                Group:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch">
            <el-select
              v-model="input_driver"
              filterable
              remote
              :remote-method="remoteMethod"
              :loading="loading"
              @change="changeDriverHandle"
              placeholder="All">
              <el-option
                v-for="item in option_driver"
                :key="item.worker_id"
                :label="item.name"
                :value="item.worker_id">
              </el-option>
              <div slot="prefix" >
                Driver:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch">
            <el-select
              v-model="input_year"
              placeholder="All"
              @change="changeYearHandle"
            >
              <el-option
                v-for="item in option_year"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
              <div slot="prefix" >
                Year:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch">
            <el-select v-model="input_date"
                       @change="changeListHandle"
                       placeholder="All">
              <el-option
                v-for="item in option_date"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
              <div slot="prefix" >
                Period:
              </div>
              <div style="clear: both">
              </div>
            </el-select>
          </div>
          <div class="innerSearch">
            <el-button type="warning" style="background: #ffc215; border: 1px solid #ffc215 !important" round @click="uploadDriversHandle">Upload </el-button>
          </div>
        </div>
        </div>

    </div>
    <div style="margin: 15px 0;"></div>
    <div class="wage_table" v-loading="wage_loading" v-if="wage_list_data.length>0">
      <div  :class="{ wage_scroll_box: wage_scoll_num >100}">
        <el-row v-if="wage_scoll_num >100">
          <el-col :span="3">
            <div class="grid-content bg-purple-dark">
              <el-row class="table_row" style="display: flex">
                <el-col style="text-align: left">
                  <div class="grid-content bg-purple line" style="display: flex">
                    <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
                    <div class="worker_name_box">Driver’s name</div>
                  </div>
                  <div class="succ_fail_title">
                    <div class="inner_time"></div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="autoWidth">
            <div class="grid-content bg-purple-dark out_scroll_box box1">
              <el-row class="table_row time_title_table">
                <el-col >
                  <div style="white-space: nowrap;line-height: 65px;">
                    <div class="inner_time"
                         :style="{width: inner_auto_width *100 +'%'}" v-for="(item,index) in time_title"
                         :key="index"
                         style="white-space: nowrap;border-bottom: none">{{item.date}}</div>
                  </div>
                  <div class="succ_fail_title">
                    <div class="inner_time" style="border-bottom: none" :style="{width: inner_auto_width *100 +'%'}"  v-for="(item,index) in time_title" :key="index">
                      <div v-if="item.total_failure >-1" class="suc">S</div>
                      <div v-if="item.total_success >-1" class="fail">F</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="fillWidth">
            <div class="grid-content bg-purple-dark">
              <el-row class="table_row">
                <el-col :span="3">
                  <div class="grid-content bg-purple line">Rate</div>
                  <div class="succ_fail_title"><div class="inner_time"></div></div>
                </el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Quan.</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Basic</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Bonus</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Adjust.</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Subtotal</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">HST</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Total</div></el-col>
                <el-col :span="3"><div class="grid-content bg-purple line">Action</div></el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row>
        <el-col :span="3">
          <div class="grid-content bg-purple-dark">
            <el-row class="table_row" style="display: flex">
              <el-col style="text-align: left">
                <div class="grid-content bg-purple line" style="display: flex">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
                  <div class="worker_name_box">Driver’s name</div>
                </div>
                <div class="succ_fail_title">
                  <div class="inner_time"></div>
                </div>
              </el-col>
            </el-row>
            <div v-for="(item,index) in wage_list_data" :key="index">
              <el-row  class="table_row">
                <el-col :span="3" style="text-align: left;display: flex">
                  <!--                 <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">-->
                  <el-checkbox v-model="item.checked" @change="handleCheckChange(item)"></el-checkbox>
                  <!--                 </el-checkbox-group>-->
                  <div class="worker_name_box">{{item.name}}</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="autoWidth">
          <div class="grid-content bg-purple-dark out_scroll_box scroll_list_box">
            <el-row class="table_row time_title_table" id="middle_top">
              <el-col >
                <div style="white-space: nowrap;line-height: 65px;">
                  <div class="inner_time"
                       :style="{width: inner_auto_width *100 +'%'}" v-for="(item,index) in time_title"
                       :key="index"
                       style="white-space: nowrap;border-bottom: none">{{item.date}}</div>
                </div>
                <div class="succ_fail_title">
                  <div class="inner_time" style="border-bottom: none" :style="{width: inner_auto_width *100 +'%'}"  v-for="(item,index) in time_title" :key="index">
                    <div v-if="item.total_failure >-1" class="suc">S</div>
                    <div v-if="item.total_success >-1" class="fail">F</div>
                  </div>
                </div>
              </el-col>
            </el-row>
            <div v-for="(item,index) in wage_list_data" :key="index">
              <el-row  class="table_row time_title_table  table_bottom " style="border-bottom: none">
                <el-col>
                  <div style="white-space: nowrap;">
                    <div class="inner_time"  :style="{width: inner_auto_width *100 +'%'}" v-for="(items,indexs) in item.time_data" :key="indexs" style="white-space: nowrap;">
                      <div>{{items.total_success}}</div>
                      <div>{{items.total_failure}}</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-col>
        <el-col :span="fillWidth">
          <div class="grid-content bg-purple-dark">
            <el-row class="table_row">
              <el-col :span="3">
                <div class="grid-content bg-purple line">Rate</div>
                <div class="succ_fail_title"><div class="inner_time"></div></div>
              </el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Quan.</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Basic</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Bonus</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Adjust.</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Subtotal</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">HST</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Total</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple line">Action</div></el-col>
            </el-row>
          </div>
          <div v-for="(item,index) in wage_list_data" :key="index">
            <el-row  class="table_row">
              <el-col :span="3" >
                <div class="grid-content bg-purple change_input" @click="changeInputHandle(item,index)">
                  <templete  v-if="item.show_rate_input">
                    <el-input v-model="item.rate"
                              @blur="showOutHandle(item)"
                              @keyup.enter.native="showOutHandle(item)"
                              :ref="`rate${index}`"
                              @input="e => { handleInput(e, item,'rate');}"
                    ></el-input>
                  </templete>
                  <span v-else>{{item.rate}}</span>
                </div>
              </el-col>
              <el-col :span="3"><div class="grid-content bg-purple">{{item.quan}}</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple">{{item.basic}}</div></el-col>
              <el-col :span="3">
                <!--           <div class="grid-content bg-purple">-->
                <!--           {{item.bonus}}-->
                <!--           </div>-->
                <div class="grid-content bg-purple change_input" @click="changeInputHandleTwo(item,index)">
                  <templete  v-if="item.show_bonus_input">
                    <el-input v-model="item.bonus"
                              @blur="showOutHandleTwo(item)"
                              :ref="`bonus${index}`"
                              @keyup.enter.native="showOutHandleTwo(item)"
                              @input=" e => { handleInput(e, item,'bonus'); }"
                    ></el-input>
                  </templete>
                  <span v-else>{{item.bonus}}</span>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple change_input" @click="changeInputHandleThree(item,index)">
                  <templete  v-if="item.show_adjust_input">
                    <el-input v-model="item.adjust"
                              @blur="showOutHandleThree(item)"
                              @keyup.enter.native="showOutHandleThree(item)"
                              :ref="`adjust${index}`"
                              @input="e => { handleInputAdjust(e, item);}"
                    ></el-input>
                  </templete>
                  <span v-else>{{item.adjust}}</span>
                </div>
              </el-col>
              <el-col :span="3" ><div class="grid-content bg-purple">{{item.subtotal}}</div></el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple change_input" @click="changeInputHandleFour(item,index)">
                  <templete  v-if="item.show_hst_input">
                    <el-select v-model="item.hst"
                               @change=" e =>{showOutHandleFour(e,item)}"
                               @blur=" e =>{showOutHandleFours(e,item)}"
                               :ref="`hst${index}`"
                    >
                      <el-option label="Incl." value="Incl"></el-option>
                      <el-option label="Excl." value="Excl"></el-option>
                      <el-option label="Out." value="Out"></el-option>
                    </el-select>
                  </templete>
                  <span v-else>{{item.hst}}.</span>
                </div>
              </el-col>
              <el-col :span="3"><div class="grid-content bg-purple">{{item.total}}</div></el-col>
              <el-col :span="3"><div class="grid-content bg-purple">
               <span style="position: relative" @click="showNoteHandle(item)">
               <img src="../assets/wageReview/edit.png" alt="" style="margin-right: 16px">
                <div class="red_point" v-if="item.wage_note != ''"></div>
               </span>
                <span style="position: relative;">
                <img src="../assets/wageReview/upload.png" alt="" @click="openUploadHandle(item)">
                <div class="red_points"  v-if="item.is_upload == 1"></div>
                </span>
              </div></el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-else class="empty">
      <div>
        <img src="../assets/image/list_blank.png" alt="">
        <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
      </div>
    </div>
  </div>
   <div v-else>
     <businessView :key="businessViewKey"></businessView>
   </div>
<!--   编辑备注弹框-->
   <el-dialog
     :close-on-click-modal="false"
     title="Note"
     :visible.sync="noteDialog"
     width="40%">
     <div style="text-align: left">
       <el-input   placeholder="Audit Note"
                   type="textarea"
                   autocomplete="off"
                   id="allInput"
                   maxlength="200"
                   :autosize="{ minRows: 4,}"
                   show-word-limit
                   v-model="note_input"
                   style="margin-top: 16px"
       ></el-input>
       <div slot="error"></div>
     </div>
     <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="noteDialog = false" plain>Cancel</el-button>
    <el-button type="primary" @click="saveEditHandle">Save</el-button>
  </span>
   </el-dialog>
<!--   同步司机弹框-->
   <el-dialog
     :close-on-click-modal="false"
     :title="upload_title"
     :visible.sync="uploadDialog"
     width="30%">
     <div style="text-align: left;margin-top: 16px">
       {{upload_mes}}
     </div>
     <span slot="footer" class="dialog-footer">
     <el-button type="danger" @click="uploadDialog = false" plain>No</el-button>
    <el-button type="primary" @click="uploadHandle">Yes</el-button>
  </span>
   </el-dialog>
 </div>
</template>

<script>
import {getWageDriverList, uploadWage} from "@/api/wageReview";
import {getWageLsit, updateWageLsit} from "@/api/wageReview";
import businessView from "@/components/businessView";
// import drivers from "@/view/drivers";
import store from "@/store";
import {getGroupList} from "@/api/driver";
import {getOrgaList} from "@/api/addressBook";

export default {
  name: "WageReview",
  components:{
    businessView
  },
  data(){
    return{
      businessViewKey:'',
      store_input:'',
      group_option:[],
      group_input:'',
      search_option_group:[],
      org_option:[],
      org_input:'',
      activeNames:'first',
      loading:false,
      upload_title:'',
      upload_mes:'Would you like to update the wage statement(s) to the driver(s)\' APP?',
      choose_single_driver:'',//选中的司机
      fillWidth:"9",
      autoWidth:"12",
      page:1,
      limit:10,
      total:2,
      uploadDialog:false,
      wage_loading:false,
      note_input:'',
      note_mes:'',
      noteDialog:false,
      checkAll:false,
      isIndeterminate: false,
      search_name:'',
      checkedCities:[],
      input_driver:'',
      option_driver:[],
      search_option_driver:[],
      input_year:'',
      option_year:[],
      input_date:'',
      option_date:[],
      start_time:"",
      end_time:'',
      time_title:[],
      wage_list_data:[],
      drivers:[],
      upload_driver:'',//单独上传司机时，需要对
    }
  },
  computed: {
    inner_auto_width() {
      if  (this.time_title.length<8){
        return 1/this.time_title.length;
      }else {
        return 0.1428
      }
    },
    wage_scoll_num(){
      return store.state.wage_scoll_num
    }
  },
  created() {
    this.option_year = this.getYearFrom2021()
    this.option_date = this.getTwoWeekRanges(this.input_year)
    this.input_date = this.getCurrentTimeRange()
    this.start_time = this.convertTimeString(this.input_year, this.input_date).start_time
    this.end_time = this.convertTimeString(this.input_year, this.input_date).end_time
    this.getWageDriverList()
    this.getWageListData()
    this.getGroup()
    this.scrollFun()
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollFun,true);
  },
  methods:{
    handleClickTops(val){
      // console.log(val,'dd')
      this.activeNames = val.name
      this.businessViewKey = new Date().getTime()
    },
    getGroup(){
      getOrgaList().then(res=>{this.org_option = res.data})
      getGroupList({page:1,limit:''}).then(res=>{
        this.group_option = res.data.data
        this.group_option.unshift({
          group_id:'',
          name:'All'
        })
        this.search_option_group = this.group_option
      })
    },
    scrollFun() {
      //监听滚动事件，将scrollTop存储vuex 在wage 页面监听取用
      let scrollTop = document.getElementsByClassName('scroll_list_box')[0].scrollLeft;
      if (this.wage_scoll_num >110){
        document.getElementsByClassName('box1')[0].scrollLeft = scrollTop
      }
    },
    wageClearAllHandle(){

    },
    uploadDriversHandle(){
      let check = this.wage_list_data.findIndex(v=>v.checked == true)
      if (check >-1){
        this.wage_list_data.forEach(v=>{
          if  (v.checked){
            this.drivers.push(v.worker_id)
          }
        })
        let is_upload = this.wage_list_data.findIndex(a=>a.is_upload == 0)
        if  (is_upload >-1){
          this.upload_title = 'Publish wage statement'
          this.upload_mes = 'Would you like to publish the wage statement(s) to the driver(s)\' APP?'
        }else {
          this.upload_title = 'Update wage statement'
          this.upload_mes = 'Would you like to update the wage statement(s) to the driver(s)\' APP?'
        }
        this.uploadDialog = true
        this.choose_single_driver = this.drivers
      }else {
        this.$message({
          type:'warning',
          message:'Please select a driver'
        })
      }

    },
    uploadHandle(){
      this.uploadDialog = false
      this.uploadDriverWageHandle(this.choose_single_driver)
    },
    uploadDriverWageHandle(ids){
      uploadWage({
        start_time:this.start_time,
        end_time:this.end_time,
        worker_ids:ids,
      }).then(res=>{
          if  (res.code == 200){
            this.choose_single_driver = []
            this.drivers = []
            if  (ids.length == 1){
              this.wage_list_data.forEach(v=>{
                if (v.worker_id == this.upload_driver.worker_id){
                  // console.log('sss',this.upload_driver,v)
                  v.is_upload = 1
                }
              })
            }
              this.$message({
                type:'success',
                message:res.msg
              })
          }
      })
    },
    openUploadHandle(item){
      this.upload_driver = item
      if  (item.is_upload == 0){
       this.upload_title = 'Publish wage statement'
        this.upload_mes = 'Would you like to publish the wage statement(s) to the driver(s)\' APP?'
      }else {
        this.upload_title = 'Update wage statement'
        this.upload_mes = 'Would you like to update the wage statement(s) to the driver(s)\' APP?'
      }
     this.choose_single_driver = [item.worker_id]
      this.uploadDialog = true
    },
    handleCurrentChange(val){
      this.page = val
      this.getWageListData()
    },
    //获取从2021 到当前的年份
    getYearFrom2021(){
      const currentYear = new Date().getFullYear();
      this.input_year = currentYear
      const startYear = 2021;
      const years = [];
      for (let year = startYear; year <= currentYear; year++) {
        years.push(year);
      }
      return years;
    },
    //输入一个年份 然后根据年份显示出所选年份中 以每个月每两周的为一个时间周期 显示
    getTwoWeekRanges(year){
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const result = [];
      for (let monthIndex = 11; monthIndex >= 0; monthIndex--) {
        const month = months[monthIndex];
        const lastDayOfMonth = new Date(year, monthIndex + 1, 0).getDate();
        // 第二时间段的结束日期
        const secondRangeEnd = lastDayOfMonth;
        // 第二时间段的开始日期
        const secondRangeStart = Math.max(15, lastDayOfMonth - 16);
        // 第一时间段的结束日期
        const firstRangeEnd = Math.min(14, secondRangeStart - 1);
        // 第一时间段的开始日期
        const firstRangeStart = Math.max(1, firstRangeEnd - 14);
        // 构建时间范围字符串并加入结果数组
        const secondRangeStr = `${month} ${secondRangeStart}-${secondRangeEnd}`;
        const firstRangeStr = `${month} ${firstRangeStart}-${firstRangeEnd}`;
        result.push(secondRangeStr, firstRangeStr);
      }
      return result.reverse(); // 倒序排列结果数组
    },
    //根据当前时间 动态计算period回显时间
    getCurrentTimeRange() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const currentMonth = currentDate.getMonth();
      const currentDay = currentDate.getDate();
      const lastDayOfMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
      const secondRangeEnd = lastDayOfMonth;
      const secondRangeStart = Math.max(15, lastDayOfMonth - 16);
      const firstRangeEnd = Math.min(14, secondRangeStart - 1);
      const firstRangeStart = Math.max(1, firstRangeEnd - 14);
      const month = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
      ][currentMonth];
      // 构建时间范围字符串
      const firstRangeStr = `${month} ${firstRangeStart}-${firstRangeEnd}`;
      const secondRangeStr = `${month} ${secondRangeStart}-${secondRangeEnd}`;
      return currentDay <= 14 ? firstRangeStr : secondRangeStr;
    },
    //修改 year 或者 period 或者司机时 都会触发以下事件 传入两个参数 然后返回一个开始时间 一个结束时间
    convertTimeString(year, dateRangeString) {
      const [month, days] = dateRangeString.split(' ');
      const [startDay, endDay] = days.split('-').map(day => day.padStart(2, '0'));

      const startDate = new Date(`${year} ${month} ${startDay}`);
      const endDate = new Date(`${year} ${month} ${endDay}`);

      const start_time = this.formatDate(startDate);
      const end_time = this.formatDate(endDate);

      return { start_time, end_time };
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      return `${year}-${month}-${day}`;
    },
    //修改年份时触发
    changeYearHandle(e){
      this.option_date = this.getTwoWeekRanges(e)
      this.start_time = this.convertTimeString(e, this.input_date).start_time
      this.end_time = this.convertTimeString(e, this.input_date).end_time
      this.getWageListData()
      this.getWageDriverList()
    },
    showNoteHandle(row){
      // noteDialog
      this.noteDialog = true
      this.note_input = row.wage_note
      this.note_mes = row
    },
    //更新备注
    saveEditHandle(){
      this.noteDialog = false
      // this.updataWageListHandle(this.note_mes)
      updateWageLsit({
        start_time:this.start_time,
        end_time:this.end_time,
        worker_id:this.note_mes.worker_id,
        wage_note:this.note_input,
      }).then(res=>{
        if (res.code == 200){
          this.wage_list_data.forEach(v=>{
            if (v.worker_id == this.note_mes.worker_id){
              v.wage_note = this.note_input
            }
          })
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      })
    },
    updataWageListHandle(row){
      updateWageLsit({
        start_time:this.start_time,
        end_time:this.end_time,
        worker_id:row.worker_id,
        rate:row.rate,
        bonus:row.bonus,
        adjust:row.adjust,
        HST:row.hst,
      }).then(res=>{
        if (res.code == 200){
          // this.note_input = row.note_input
          this.wage_list_data.forEach(v=>{
            if (v.worker_id == row.worker_id){
              v.basic = v.rate*v.quan
              v.basic = Math.round(Number(v.basic)  * 100) / 100;
              v.subtotal =Number(row.bonus ) +Number(row.adjust)  + Number(row.basic)
              v.subtotal = Math.round(Number(v.subtotal)  * 100) / 100;
              if (row.hst == 'Incl'){
                v.total =v.subtotal
                v.total = Math.round(Number(v.total)  * 100) / 100;
              }else if  (row.hst == 'Excl'){
                v.total =(Number(v.subtotal)*113)/100
                v.total = Math.round(Number(v.total)  * 100) / 100;
              }else {
                v.total = v.subtotal
               v.total = Math.round(Number(v.total)  * 100) / 100;
              }
            // v.wage_note = this.note_input
            }
          })
          // this.getWageListData()
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      })
    },
    getWageListData(){
      this.wage_loading = true
      getWageLsit({
        page:this.page,
        limit:this.limit,
        start_time:this.start_time,
        end_time:this.end_time,
        worker_id:this.input_driver,
        group_id:this.group_input,
        table_type:0
      }).then(res=>{
        this.wage_loading =false
        if (res.code == 200){
          const obj = {}
          res.data.forEach(v=>{
              v.checked = false
              v.show_rate_input = false
              v.show_bonus_input = false
              v.show_adjust_input = false
              v.show_hst_input = false
            for (let key of Object.keys(v.data)) {
              if(!Object.prototype.hasOwnProperty.call(obj, key)) {
                obj[key] = v.data[key]
              }
            }
            v.time_data =obj
          })
          this.wage_list_data = res.data
          //需要正对不同司机的不同时间做数组对齐 比如a司机的时间1 有任务；b司机的时间2有任务，那么需要对a司机的时间2、b司机的时间1做空处理
          //这里选择遍历time_title对象，取time_title的key 跟每个司机中的data 做比较，如果不相等 则添加空；注意需要跟原本 0 项做区分
          const arrPrototype = Object.keys(obj)
          this.wage_list_data.forEach((item, index) => {
            for(let key of arrPrototype) {
              if (!Object.prototype.hasOwnProperty.call(item.data, key)){
                item.data[key] = {
                  total_failure:0,
                  total_success:0
                }
              }
            }
            let transformedData = [];
            for (const [date, values] of Object.entries(item.data)) {
              let transformedItem = { date, ...values };
              transformedData.push(transformedItem);
            }
            let sortedData = transformedData.sort((a, b) => {
              return arrPrototype.indexOf(a.date) - arrPrototype.indexOf(b.date);
            });
            item.time_data = sortedData
          })
          // this.wage_list_data.push({
          //   worker_id:1,
          //   name:'All',
          //   rate:'11',
          //   bonus:'11',
          //   adjust:'11',
          //   hst:'Incl',
          //   data:{
          //     '2024-01-01':{
          //       total_success:0,
          //       total_failure:0
          //     }
          //   }
          // })
          this.$nextTick(() => {
            this.time_title = this.wage_list_data[0]?.time_data
            let length = this.time_title.length
            switch (length){
              case 1:
                  this.autoWidth = 3
                  this.fillWidth = 18
                break;
              case 2:
                this.autoWidth = 4
                this.fillWidth = 17
                break;
              case 3:
                this.autoWidth = 6
                this.fillWidth = 15
                break;
              case 4:
                this.autoWidth = 8
                this.fillWidth = 13
                break;
              case 5:
                this.autoWidth = 10
                this.fillWidth = 11
                break;
              case 6:
                this.autoWidth = 12
                this.fillWidth = 9
                break;
              case 7 :
                this.autoWidth = 12
                this.fillWidth = 9
                break;
            }
            if  (length >7){
              this.autoWidth = 12
              this.fillWidth = 9
            }
          })
          window.addEventListener("scroll", this.scrollFun,true);
        }else {
          this.$message({
            type:'warning',
            message:res.msg
          })
        }
      }).catch(err=>{
        this.$message({
          type:"error",
          message:err
        })
      })
    },
    getWageDriverList(){
      getWageDriverList({
        start_time:this.start_time,
        end_time:this.end_time,
        name:this.search_name,
      }).then(res=>{
          if (res.code == 200){
            this.option_driver = res.data
            if  (this.option_driver.length >0){
              this.option_driver.unshift({
                worker_id:'',
                name:'All'
              })
            }
            this.search_option_driver = this.option_driver
          }else {
            this.$message({
              type:'warning',
              message:res.msg
            })
          }
      })
    },
    handleCheckedCitiesChange(value){
      console.log(value,'value')
    },
    handleCheckAllChange(val) {
      if (val){
        this.wage_list_data.forEach(v=>{
          v.checked = true
        })
      }else {
        this.wage_list_data.forEach(v=>{
          v.checked =false
        })
      }
      this.isIndeterminate =false;
      console.log(this.isIndeterminate)
    },
    handleCheckChange(a){
      let arr = []
      this.wage_list_data.forEach(v=>{
        if (v.checked){
          arr.push(v)
        }
      })
      this.isIndeterminate = arr.length > 0 && arr.length < this.wage_list_data.length
    },
    changeInputHandle(row,index){
      row.show_rate_input = true
      setTimeout(()=>{
        this.$refs['rate'+index][0].focus()
      })
      console.log(row,'dd')

    },
    showOutHandle(row){
      //如果input 为空 就恢复原来的值
      row.show_rate_input =false
      this.updataWageListHandle(row)
    },
    changeInputHandleTwo(row,index){
      row.show_bonus_input = true
      setTimeout(()=>{
        console.log(this.$refs)
        this.$refs['bonus'+index][0].focus()
      },100)
    },
    showOutHandleTwo(row){
      row.show_bonus_input =false
      // 调用接口 将当前修改的值传给后端
      this.updataWageListHandle(row)
    },
    changeInputHandleThree(row,index){
      row.show_adjust_input = true
      setTimeout(()=>{
        this.$refs['adjust'+index][0].focus()
      },100)
    },
    showOutHandleThree(row){
      row.show_adjust_input =false
      this.updataWageListHandle(row)
    },
    changeInputHandleFour(row,index){
      row.show_hst_input = true
      setTimeout(()=>{
        this.$refs['hst'+index][0].toggleMenu()
      },100)
    },
    showOutHandleFour(e,row){
      console.log(row,'ddd',e)
      row.show_hst_input =false
      this.updataWageListHandle(row)
    },
    showOutHandleFours(e,row){
      setTimeout(()=>{
        row.show_hst_input =false
      },200)
    },
    selectHstHandle(){
      console.log('ddddddddd')
    },
    handleInput(v,item,type) {
      // 移除非数字和小数点以外的字符
      let sanitizedValue = v.replace(/[^\d.]/g, '');

      // 确保只有一个小数点
      const parts = sanitizedValue.split('.');
      if (parts.length > 2) {
        sanitizedValue = parts[0] + '.' + parts.slice(1).join('');
      }

      // 限制小数点后只能有两位数字
      if (parts.length === 2 && parts[1].length > 2) {
        sanitizedValue = parts[0] + '.' + parts[1].substring(0, 2);
      }

      // 防止以小数点开头
      if (sanitizedValue.startsWith('.')) {
        sanitizedValue = '0' + sanitizedValue;
      }

      // 防止多个小数点
      sanitizedValue = sanitizedValue.replace(/\.+/g, '.');

      // 限制整数部分长度（假设最多6位整数）
      // if (parts.length > 0 && parts[0].length > 6) {
      //   sanitizedValue = parts[0].substring(0, 6) + (parts[1] ? '.' + parts[1] : '');
      // }

      // 更新输入框的值
      if (type == 'rate'){
        item.rate = sanitizedValue;
      }else {
        item.bonus = sanitizedValue;
      }
    },
    handleInputAdjust(v,item){
      let value = v.replace(/[^\-\d.]/g, '') // 只能输入.和-和数字
      value = value.replace(/^\./g, '')  //第一个字符不能是.
      value = value.replace(/\.{2,}/g, '.') // 不能连续输入.
      value = value.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
      value = value.replace(/(-)\./g, '$1') // -后面不能输入.
      // value = value.replace(/\-{2,}/g, '-') // -只能保留一个
      value = value.replace(/(\d+|\.)-/g, '$1') // 数字和.后面不能接-,不能出现类似11-, 12.-
      value = value.replace(/-(0){2,}/g, "$1") // 不能出现-00,-001,-0001类似
      value = value.replace(/(-)0+(\d+)/g, '$1$2') // 不能出现-01,-02类似
      value = value.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
      value = value.replace(/(\d{7})\d*/, '$1') // 最多保留7位整数
      value = value.replace(/(\.\d{2})\d*/, '$1')// 最多保留2位小数
      item.adjust = value
    },
    changeListHandle(){
      console.log(this.input_date)
      this.start_time = this.convertTimeString(this.input_year, this.input_date).start_time
      this.end_time = this.convertTimeString(this.input_year, this.input_date).end_time
      this.getWageListData()
      this.getWageDriverList()
    },
    remoteMethod(val){
       this.search_name = val
      let arr = this.search_option_driver
      let result = arr.filter(item => item.name.includes(val));
       this.option_driver = result
    },
    remoteGroupMethod(val){
      let arr = this.search_option_group
      let result = arr.filter(item => item.name.includes(val));
      this.group_option = result
    },
    changeGroupHandle(){
      this.getWageListData()
      this.group_option = this.search_option_group
    },
    changeDriverHandle(val){
      console.log(val)
      this.getWageListData()
      this.option_driver = this.search_option_driver
    }
  }
}
</script>

<style scoped lang="less">
.box1::-webkit-scrollbar-thumb {
  background: #ffffff;
  //height: 1px;
  visibility: visible;
}
.box1::-webkit-scrollbar {
  background: #ffffff;
  visibility: visible;

}
.scroll_list_box{
  //position: absolute;
}
.wage_scroll_box {
  position: fixed;
  top: 65px;
  z-index: 3;
  width: calc(100% - 264px);
  border-radius: 16px;
  background-color: #FFFFFF;
}
.empty {
  width: 200px;
  height: calc(100vh - 258px);
  margin: 20px auto;
  position: relative;
  img {
    width: 100%;
    height: 200px;
  }
  div {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.tasksTop{
  padding: 8px;
  background: #FFFFFF;
  border-radius: 16px;
  border: 1px solid #E0E0E0;
  display: flex;
  justify-content: space-between;
  /deep/.changeFocus:focus{
    border: 1px solid #DCDFE6;
    color: #606266;
  }
  .topSeach{
    display: flex;
    justify-content: space-between;
    //flex-wrap: wrap;
    width: 100%;
    /deep/ .el-input--prefix .el-input__inner{
      padding-left: 88px;
    }
    /deep/ .el-input__prefix{
      color: #1F2D42;
    }
    .long_search{
      /deep/.el-input__inner{
        padding-left: 115px!important;
      }
    }
    .long_searchs{
      /deep/.el-input__inner{
        padding-left: 133px!important;
      }
    }
    .orgInput{
      /deep/.el-input--prefix .el-input__inner{
        padding-left: 130px!important;
      }
    }
    .innerSearch{
      margin: 8px;
      /deep/.el-cascader{
        line-height: 0;
      }
      .innerTime{
        /deep/.el-input__prefix{
          position: absolute;
          top: 0;
          right: 12px;
          left: auto;
        }
        /deep/ .el-input--prefix .el-input__inner{
          padding-left: 12px;
        }
        /deep/.el-input__icon{
          //position: absolute;
          //right: 12px;
          color: #D65953;
        }
      }
      .from{
        /deep/.el-input__inner{
          padding-left: 75px!important;
        }
      }
      .to{
        /deep/.el-input__inner{
          padding-left: 55px!important;
        }
      }
    }
    .cascader{
      position: relative;
      /deep/.el-input__inner{
        padding-left: 80px;
      }
      .slot{
        position: absolute;
        padding-left: 24px;
        font-size: 14px;
        top: 5px;
      }
    }
    .ex{
      width: 300px;
      /deep/ .el-input--prefix .el-input__inner{
        padding-left: 110px;
      }
    }
  }

}
.wage_table{
  padding: 0 8px;
  background: #FFFFFF;
  border-radius: 16px;
  margin-top: 16px;

  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #1F2D42;
  line-height: 20px;
  .table_row{
    line-height: 64px;
    border-bottom: 1px solid #E0E0E0;
    .line{
      border-bottom: 1px solid #E0E0E0;
    }
    img{
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
    .red_point{
      position: absolute;
      top: -2px;
      right: 14px;
      width: 5px;
      height: 5px;
      background-color: #EB3F3F;
      border-radius: 50%;

    }
    .red_points{
      position: absolute;
      top: -2px;
      left: 14px;
      width: 5px;
      height: 5px;
      background-color: #82D237;
      border-radius: 50%;
    }
    .worker_name_box{
      white-space:nowrap;
      display: flex;
      margin-left: 16px;
    }
  }
  .time_title_table{
    text-align: left;
      .inner_time{
        text-align: center;
      }
  }
  .table_bottom{
    .inner_time{
      border-bottom: 1px solid #E0E0E0!important;
    }
  }
  .time_title_box{
    line-height: 20px;
    overflow-x: hidden;
  }
  .inner_time{
    display: inline-block;
    //width: 14.28%;
    div{
      width: 50%;
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
    }
  }
  .succ_fail_title{
  white-space: nowrap;
  //overflow-x: hidden;
    height: 28px;
    line-height: 28px;
    .inner_time{
      display: inline-block;
      //width: 14.28%;
      .suc{
        background-color: #82D237;
        width: 50%;
      }
      .fail{
        background-color: #E95646;
        width: 50%;
      }
      div{
        display: inline-block;
        font-size: 14px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }

  .change_input{
    cursor: pointer;
    /deep/ .el-input__inner{
      text-align: center;
      border-radius: 10px;
    }
  }
  .out_scroll_box{
    width: 100%;
    overflow: auto;
    max-width: 100%;
  }
}
/deep/.el-col-2 {
  width: 5%;
}
/deep/.el-col-3{
  width: 11%;
}
/deep/.el-col-11 {
  width: 44.83333%;
}
/deep/.el-col{
  min-width: 40px;
}
.btomPagin{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  padding-left: 16px;
  .innerLeft{
    font-size: 16px;
    font-family: SFPro-Regular, SFPro;
    font-weight: 400;
    color: #1F2D42;
    line-height: 20px;
  }
}
.top_tabs{
  width: 322px;
  text-align: center;
  margin-bottom: 24px;
  /deep/.el-tabs__nav{
    background-color: #ECECF2!important;
    border-radius: 16px;
  }
  /deep/.el-tabs__header{
    margin: 0;
  }

  /deep/ .el-tabs__nav-scroll{
    padding-left: 0;
  }
  /deep/  .el-tabs__nav-wrap::after{
    background: none ;
  }
  /deep/  .el-tabs__item{
    height: 32px;
    line-height: 32px;
    flex: 1;
    padding-left: 0!important;
    padding-right: 0!important;
  }
  /deep/ .el-tabs__item.is-active{
    background: #E95646;
    color: #FFFFFF;
    border-radius: 16px;
  }
  /deep/.el-tabs__active-bar {
    background: none;
  }
}
</style>
